import Api from "@/services/api";

const basic = "billing";
export default {
  get(id) {
    return Api.default().get("/" + basic + "?participantId=" + id);
  },
};
